export default "__VITE_ASSET__DYsAMypk__"